"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _draftJs = require("draft-js");

var _reactDraftWysiwyg = require("react-draft-wysiwyg");

require("react-draft-wysiwyg/dist/react-draft-wysiwyg.css");

var _draftJsImportHtml = require("draft-js-import-html");

var _draftJsExportHtml = require("draft-js-export-html");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var StyledWysiwyg = _styledComponents["default"].div.attrs(function () {
  return {};
}).withConfig({
  displayName: "Best-Wysiwyg__StyledWysiwyg",
  componentId: "vz89j3-0"
})(["&&&{.rdw-editor-toolbar{background:", ";border-radius:", "px;border:none;margin-bottom:0px;height:", "px;font-size:", "px;}.DraftEditor-editorContainer{border:", ";height:", "px;padding-top:", "px;padding-left:", "px;}.rdw-history-wrapper{background-color:", ";}.rdw-text-align-wrapper{background-color:", ";margin-right:", "px;}.rdw-text-align-wrapper{border:none;height:", "px;}.rdw-option-wrapper{border:none;height:", "px;}.rdw-list-wrapper{background-color:", ";}.rdw-option-active{background-color:", ";}}"], function (props) {
  return props.styles.editorToolbarBackground ? props.styles.editorToolbarBackground : "#ffffff";
}, function (props) {
  return props.styles.editorToolbarBorderRadius ? props.styles.editorToolbarBorderRadius : "4";
}, function (props) {
  return props.styles.toolbarHeight ? props.styles.toolbarHeight : "40";
}, function (props) {
  return props.styles.fontSize ? props.styles.fontSize : "14";
}, function (props) {
  return props.border ? props.border : "solid 1px #ffffff";
}, function (props) {
  return props.editorHeight ? props.editorHeight : "120";
}, function (props) {
  return props.editorPaddingTop ? props.editorPaddingTop : "5";
}, function (props) {
  return props.editorPaddingLeft ? props.editorPaddingLeft : "10";
}, function (props) {
  return props.historyWrapperColor ? props.historyWrapperColor : "#ffffff";
}, function (props) {
  return props.textAlignWrapperColor ? props.textAlignWrapperColor : "#ffffff";
}, function (props) {
  return props.textAlignMarginRight ? props.textAlignMarginRight : "2";
}, function (props) {
  return props.textAlignWrapperHeight ? props.textAlignWrapperHeight : "30";
}, function (props) {
  return props.optionWrapperHeight ? props.optionWrapperHeight : "30";
}, function (props) {
  return props.listWrapperColor ? props.listWrapperColor : "#ffffff";
}, function (props) {
  return props.activeOptionColor ? props.activeOptionColor : "#d8d8d8";
});

var WysiwygFooter = _styledComponents["default"].div.attrs(function () {
  return {};
}).withConfig({
  displayName: "Best-Wysiwyg__WysiwygFooter",
  componentId: "vz89j3-1"
})(["width:100%;height:", "px;background:", ";border-radius:", "px;"], function (props) {
  return props.footerHeight ? props.footerHeight : "25";
}, function (props) {
  return props.footerBackground ? props.footerBackground : "#ffffff";
}, function (props) {
  return props.footerBorderRadius ? props.footerBorderRadius : "4";
});

var blockStyleFn = function blockStyleFn(block) {
  var data = block.getData();
  if (data.size == 0) return;

  if (data.get("text-align")) {
    return {
      style: {
        textAlign: data.get("text-align")
      }
    };
  }
};

var customBlockFn = function customBlockFn(element) {
  if (element.style.textAlign) {
    return {
      data: {
        "text-align": element.style.textAlign
      }
    };
  }
};

var defaultProps = {
  toolbarOptions: ["history", "blockType", "inline", "textAlign", "list"],
  inlineProps: {
    inDropdown: false,
    inlineOptions: ["bold", "italic"]
  },
  listProps: {
    inDropdown: false
  },
  textAlignProps: {
    inDropdown: false
  }
};

var BestWYSIWYG = function BestWYSIWYG(_ref) {
  var initialValue = _ref.initialValue,
      onChange = _ref.onChange,
      toolbarOptionsProps = _ref.toolbarOptionsProps,
      styles = _ref.styles;

  var _useState = (0, _react.useState)(_draftJs.EditorState.createWithContent((0, _draftJsImportHtml.stateFromHTML)(initialValue, {
    customBlockFn: customBlockFn
  }))),
      _useState2 = _slicedToArray(_useState, 2),
      editorState = _useState2[0],
      setEditorState = _useState2[1];

  var Options = _objectSpread({}, defaultProps, {}, toolbarOptionsProps);

  (0, _react.useEffect)(function () {
    var currentContent = editorState.getCurrentContent().hasText() ? (0, _draftJsExportHtml.stateToHTML)(editorState.getCurrentContent(), {
      blockStyleFn: blockStyleFn
    }) : "";
    onChange(currentContent);
  }, [editorState]);

  var tabAction = function tabAction(e) {
    if (e) {
      e.preventDefault();
    }

    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var blockType = content.getBlockForKey(selection.getStartKey()).getType();

    if (/(un)?ordered-list-item/i.test(blockType)) {
      setEditorState(_draftJs.RichUtils.onTab(e, editorState, 3));
    } else {
      var newState = _draftJs.Modifier.replaceText(content, selection, "    ");

      setEditorState(_draftJs.EditorState.push(editorState, newState, "insert-characters"));
    }
  };

  return _react["default"].createElement(StyledWysiwyg, {
    styles: styles
  }, _react["default"].createElement(_reactDraftWysiwyg.Editor, {
    editorState: editorState,
    onEditorStateChange: setEditorState,
    toolbar: {
      options: Options.toolbarOptions,
      history: {
        options: ["undo", "redo"]
      },
      inline: {
        inDropdown: Options.inlineProps.inlineInDropdown,
        options: Options.inlineProps.inlineOptions,
        bold: {}
      },
      list: {
        inDropdown: Options.listProps.inDropdown,
        options: Options.listProps.listOptions
      },
      textAlign: {
        inDropdown: Options.textAlignProps.inDropdown
      }
    },
    onTab: tabAction
  }), _react["default"].createElement(WysiwygFooter, {
    styles: styles
  }));
};

BestWYSIWYG.propTypes = {
  /** Initial value of the WYSIWYG */
  initialValue: _propTypes["default"].string,

  /** onChange Handler to handle editor state change */
  onChange: _propTypes["default"].func,

  /** Columns to display differently on a tablet.  If these are not present it will only change on a mobile device */
  toolbarOptionsProps: _propTypes["default"].shape({
    toolbarOptions: _propTypes["default"].arrayOf(_propTypes["default"].string),
    inlineProps: _propTypes["default"].shape({
      inDropdown: _propTypes["default"].bool,
      inlineOptions: _propTypes["default"].arrayOf(_propTypes["default"].string)
    }),
    listProps: _propTypes["default"].shape({
      inDropdown: _propTypes["default"].bool
    }),
    textAlignProps: _propTypes["default"].shape({
      inDropdown: _propTypes["default"].bool
    })
  }),
  styles: _propTypes["default"].object
};
BestWYSIWYG.defaultProps = {
  initialValue: "Hello, world!",
  onChange: function onChange() {},
  toolbarOptionsProps: defaultProps,
  styles: {}
};
var _default = BestWYSIWYG;
exports["default"] = _default;